// extracted by mini-css-extract-plugin
export default {"sourceCard":"source-card_sourceCard__O2gZT","noteIndicator":"source-card_noteIndicator__BwS+A","singleSource":"source-card_singleSource__gggia"};